/** Brand colors an admin can pick for a department folder. */
export const DEPARTMENT_COLORS = ['#005EAD', '#0070C0', '#95B9DB', '#212121', '#595959'] as const;
